<template>
  <div class="row vh-100">
    <div class="loading-container">
      <div class="overlay" v-show="loading">
        <div class="text-center">
          <img class="loading-gif" src="/static/img/blabla.svg" alt="loading-spinner"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnwrRedirect",
  data() {
    return {
      loading: false,
      uri: '',
      client_id: ''
    }
  },
  methods: {
    oktaRedirectLink () {
      this.loading = true
      let productionURLs = ['cs.qb-schuhe.de']
      if ((productionURLs.indexOf(window.location.hostname)) !== -1) {
        this.uri = 'https://cs.qb-schuhe.de/redirect'
        this.client_id = '0oa4g4msr3RIVXmyQ417'
      } else if (window.location.hostname === 'cs.staging-qb.de') {
        this.uri = 'https://cs.staging-qb.de/redirect'
        this.client_id = '0oa42vsjqpVWsYxlS417'
      }
      window.location.href = `https://login.anwr-group.com/oauth2/v1/authorize?client_id=${this.client_id}&response_type=code&response_mode=query&scope=openid+email+profile&redirect_uri=${this.uri}&state=ApplicationState`
    }
  },
  mounted() {
    this.oktaRedirectLink()
    this.loading = false
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/AnwrRedirect.vue